import React, { Component } from 'react';
import { TIMETABLE_PATH } from '../../../constants/routes';

class FestivalTitle extends Component {
    state = { menuOpen: false };

    _openMenu = () => {
        this.props.events && this.props.events.length && this.setState({ menuOpen: true });
    };
    _closeMenu = () => this.setState({ menuOpen: false });

    render() {
        return (
            <div className="ckp-timetable-title rp-hidden-760-min">
                <h1
                    className={`ckp-ts-h1-a ckp-timetable-title-label ${
                        this.props.events && this.props.events.length ? '' : 'is-not-a-menu'
                    } ${this.state.menuOpen ? 'is-open' : ''}`}
                    onClick={this._openMenu}
                >
                    {this.props.title}
                </h1>

                {this.state.menuOpen && (
                    <ul className="ckp-timetable-title-menu">
                        {this.props.events.map(e => (
                            <li
                                key={e.value}
                                className={`ckp-timetable-title-option u-truncate ${
                                    this.props.selectedEvent === e.value ? 'is-selected' : ''
                                }`}
                            >
                                <a href={TIMETABLE_PATH.replace(':id', e.value)}>{e.label}</a>
                            </li>
                        ))}
                    </ul>
                )}
                {this.state.menuOpen && <div onClick={this._closeMenu} className="ckp-timetable-title-overlay" />}
            </div>
        );
    }
}

export default FestivalTitle;



// WEBPACK FOOTER //
// ./src/components/application/timetable/TimetableTitle.js